import apiService from "../api/ApiService";

declare type Env = {
  name: string;
  wario: string;
  wsConnect: string;
  api: string;
  wsNotif: string;
  app: string;
  gamepad: string;
  analytics: string;
};
const getEnv = (env?: string): Env => {
  const _env = env || apiService.endpoint;
  if (_env.match(/dev/)) {
    return {
      name: "dev",
      wario: "https://dev-profile.blacknut.net",
      wsConnect: "wss://dev-ws.blacknut.net/api/v1/ws/login",
      api: "https://dev-api.blacknut.net/api",
      wsNotif: "wss://dev-ws.blacknut.net/api/v1/ws/notifications",
      app: "https://dev-app.blacknut.net",
      gamepad: "https://dev-gamepad.blacknut.net",
      analytics: "https://a.blacknut.com/dev",
    };
  } else if (_env.match(/staging/)) {
    return {
      name: "staging",
      wario: "https://staging-profile.blacknut.net",
      wsConnect: "wss://staging-ws.blacknut.net/api/v1/ws/login",
      api: "https://staging-api.blacknut.net/api",
      wsNotif: "wss://staging-ws.blacknut.net/api/v1/ws/notifications",
      app: "https://staging-app.blacknut.net",
      gamepad: "https://staging-gamepad.blacknut.net",
      analytics: "https://a.blacknut.com/staging",
    };
  } else if (_env.match(/integration/)) {
    return {
      name: "integration",
      wario: "https://integration-profile.blacknut.net",
      wsConnect: "wss://integration-ws.blacknut.net/api/v1/ws/login",
      api: "https://integration-api.blacknut.net/api",
      wsNotif: "wss://integration-ws.blacknut.net/api/v1/ws/notifications",
      app: "https://integration-app.blacknut.net",
      gamepad: "https://integration-gamepad.blacknut.net",
      analytics: "https://a.blacknut.com/integration",
    };
  }
  return {
    name: "prod",
    wario: "https://profile.blacknut.com",
    wsConnect: "wss://ws.blacknut.com/api/v1/ws/login",
    api: "https://api.blacknut.com/api",
    wsNotif: "wss://ws.blacknut.com/api/v1/ws/notifications",
    app: "https://app.blacknut.com",
    gamepad: "https://gamepad.blacknut.com",
    analytics: "https://a.blacknut.com/event",
  };
};
export default getEnv;
export { getEnv };
